var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-column',_vm._b({staticClass:"pt-0 pb-0"},'w-column',_vm.$props,false),[_vm._t("divider-layout-wrapper",function(){return [_c('w-divided-in-divider-layout-wrapper',{class:{ 'fill-height': _vm.fillHeight }},[_vm._t("default")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }